import { isNil } from 'lodash-es';
import SectionRow from '../SectionRow';
import { TrialAnsweredQuestionModel, TrialQuestion } from '@/api/apis/case';
import { trialAnswerNames } from '@/constants/case/case.constants';

interface TrialQASectionProps {
  label: string;
  question: TrialQuestion;
  questionnaire: TrialAnsweredQuestionModel[];
}

export const TrialQASection = ({ label, question, questionnaire }: TrialQASectionProps) => {
  const qaRecord = questionnaire.find((q) => q.question === question);

  if (isNil(qaRecord)) return null;

  const { answer, customAnswer } = qaRecord;
  return (
    <SectionRow key={question} label={label} truncate={false}>
      <div className="flex flex-col gap-2">
        <div>{trialAnswerNames[answer]}</div>
        {customAnswer && <div className="text-xs-r">{customAnswer}</div>}
      </div>
    </SectionRow>
  );
};
